import {useCallback} from 'react'
import ApiSdk from 'services/callApi'
import {Notification} from '@binance/uikit'
import {useMappedState, useDispatch} from 'redux-react-hook'
import {entities as entitiesAction} from 'actions'
import {SETTING} from 'constants'
import {userCurLeverageFn} from 'utils/futures'
import useRouter from 'hooks/useRouter'

const adjustSuccess = i18n => Notification({
  content: i18n['adjustLeverage-success'] || 'Adjust leverage success',
  type: 'success',
  duration: 3000
})

export default function useLeverageData (i18n) {
  const router = useRouter()
  const {symbol, lng} = router.query
  const dispatch = useDispatch()
  const mapState = useCallback(state => {
    const positions = state?.entities?.positions || {}
    const leverageData = state?.entities?.leverageData
    || {curLeverage: SETTING.leverageInfo.defaultVal}
    const userNotionalValue = positions?.[symbol]?.notionalValue || 0
    leverageData.userNotionalValue = userNotionalValue
    leverageData.userCurLeverage = userCurLeverageFn(userNotionalValue)
    return leverageData
  }, [symbol])
  const leverageData = useMappedState(mapState)
  const updateLeverage = useCallback(
    curLeverage => {
      if (curLeverage !== leverageData.curLeverage) {
        updateUserLeverage(curLeverage)
      } else {
        adjustSuccess(i18n)
      }
    },
    [i18n, leverageData.curLeverage, updateUserLeverage]
  )

  const updateUserLeverage = useCallback(async leverage => {
    const res = await ApiSdk.futures.adjustLeverage(symbol, leverage, {
      lang: lng
    })

    if (res?.hasOwnProperty('error')) {
      Notification({
        content: res.error || i18n['adjustLeverage-failure'],
        type: 'error',
        duration: 3000
      })
    } else {
      leverageData.curLeverage = leverage
      dispatch(entitiesAction({leverageData}))
      adjustSuccess(i18n)
    }
  }, [dispatch, i18n, leverageData, lng, symbol])

  return {
    leverageData,
    updateLeverage,
  }
}
